import React, { useEffect } from "react";
import { useWriteContract, useWaitForTransactionReceipt } from 'wagmi';


import { MemoriesConfig } from '../services/web3';
import Loader from "./Loader";

const MemoryformMint = ({ data, setMinted }) => {
  const { data: hash, writeContract } = useWriteContract()
  const { metadata, nonce, auth } = data;

  const { isLoading: isConfirming, isSuccess: isConfirmed } = useWaitForTransactionReceipt({
    hash,
  })

  const onSubmit = (e) => {
    e.preventDefault()
    writeContract({
      to: MemoriesConfig.address,
      abi: MemoriesConfig.abi,
      functionName: 'mint',
      args: [metadata, nonce, auth],
    })
  }

  useEffect(() => { 
    if (isConfirmed) {
      setMinted(true)
    }
  }, [isConfirmed, setMinted])

  return (
    <form onSubmit={onSubmit}>
      <div className="memoryformIntro">
        {!isConfirmed && !isConfirming ? <div className="button-parent"><input type="submit" value="Send Transaction"/></div> : null}
        {hash && <div className="hash">Transaction Sent: {hash}</div>}
        {isConfirming && <Loader />}
        {isConfirmed && <div>Transaction confirmed.</div>}
      </div>
    </form>
  )
}

export default MemoryformMint;